import { Bounds, Vector } from '@ardoq/graph';

import {
  rectContains,
  rectHeight,
  rectWidth,
} from 'tabview/visualizations/misc/geometry';
import {
  AQBLOCKS_DROPSHADOW_FILL,
  AQBLOCKS_HANDLE_FILL,
  AQBLOCKS_HANDLE_GRABSIZE,
  AQBLOCKS_HANDLE_SIZE,
  AQBLOCKS_HANDLE_STROKE,
} from '../consts';
import { RenderParameters } from './types';
import { DragOperation } from '../interactions/types';

export const renderNodeHandlesShadows = (
  rc: Bounds,
  params: RenderParameters
) => {
  const pixel = 1;
  const sz = Math.ceil(AQBLOCKS_HANDLE_SIZE / 2);

  const renderHandle = (left: number, top: number) => {
    params.ctx.fillRect(left, top, 1 + 2 * sz, 1 + 2 * sz);
  };

  const lx = rc[0] - sz;
  const rx = rc[2] - sz;
  const cx = 0.5 + Math.round(0.5 * (lx + rx));
  const ty = rc[1] - sz;
  const by = rc[3] - sz;
  const cy = 0.5 + Math.round(0.5 * (ty + by));
  const offset = 3;

  params.ctx.fillStyle = AQBLOCKS_DROPSHADOW_FILL;
  params.ctx.strokeStyle = AQBLOCKS_DROPSHADOW_FILL;
  params.ctx.lineWidth = 1 * pixel;

  renderHandle(lx + offset, ty + offset);
  renderHandle(cx + offset, ty + offset);
  renderHandle(rx + offset, ty + offset);
  renderHandle(lx + offset, cy + offset);
  renderHandle(rx + offset, cy + offset);
  renderHandle(lx + offset, by + offset);
  renderHandle(cx + offset, by + offset);
  renderHandle(rx + offset, by + offset);
};

export const renderNodeHandles = (rc: Bounds, params: RenderParameters) => {
  const pixel = 1;
  const sz = Math.ceil(AQBLOCKS_HANDLE_SIZE / 2);
  const { ctx } = params;

  const renderHandle = (left: number, top: number) => {
    ctx.fillRect(left, top, 1 + 2 * sz, 1 + 2 * sz);
    ctx.strokeRect(left, top, 1 + 2 * sz, 1 + 2 * sz);
  };

  const lx = rc[0] - sz;
  const rx = rc[2] - sz;
  const cx = 0.5 + Math.round(0.5 * (lx + rx));
  const ty = rc[1] - sz;
  const by = rc[3] - sz;
  const cy = 0.5 + Math.round(0.5 * (ty + by));

  ctx.fillStyle = AQBLOCKS_HANDLE_FILL;
  ctx.strokeStyle = AQBLOCKS_HANDLE_STROKE;
  ctx.lineWidth = 1 * pixel;

  ctx.strokeRect(rc[0], rc[1], rectWidth(rc), rectHeight(rc));
  renderHandle(lx, ty);
  renderHandle(cx, ty);
  renderHandle(rx, ty);
  renderHandle(lx, cy);
  renderHandle(rx, cy);
  renderHandle(lx, by);
  renderHandle(cx, by);
  renderHandle(rx, by);
};

export const hitTestNodeHandles = (
  rc: Bounds,
  pos: Vector,
  resolution: number
) => {
  const grabSize = AQBLOCKS_HANDLE_GRABSIZE * resolution;
  const lx = Math.round(rc[0] - grabSize / 2);
  const cx = Math.round((rc[0] + rc[2]) / 2 - grabSize / 2);
  const rx = Math.round(rc[2] - grabSize / 2);
  const ty = Math.round(rc[1] - grabSize / 2);
  const cy = Math.round((rc[1] + rc[3]) / 2 - grabSize / 2);
  const by = Math.round(rc[3] - grabSize / 2);

  if (rectContains([lx, cy, lx + grabSize, cy + grabSize], pos)) {
    return DragOperation.Left;
  }
  if (rectContains([lx, ty, lx + grabSize, ty + grabSize], pos)) {
    return DragOperation.LeftTop;
  }
  if (rectContains([cx, ty, cx + grabSize, ty + grabSize], pos)) {
    return DragOperation.Top;
  }
  if (rectContains([rx, ty, rx + grabSize, ty + grabSize], pos)) {
    return DragOperation.RightTop;
  }
  if (rectContains([rx, cy, rx + grabSize, cy + grabSize], pos)) {
    return DragOperation.Right;
  }
  if (rectContains([rx, by, rx + grabSize, by + grabSize], pos)) {
    return DragOperation.RightBottom;
  }
  if (rectContains([cx, by, cx + grabSize, by + grabSize], pos)) {
    return DragOperation.Bottom;
  }
  if (rectContains([lx, by, lx + grabSize, by + grabSize], pos)) {
    return DragOperation.LeftBottom;
  }

  return DragOperation.None;
};
